/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { IApiList, IDaySegment } from '../../../types';
import { DaySegments } from './types';

const initialState: IApiList<IDaySegment> | null = null;

export const daySegmentsReducer: Reducer<IApiList<IDaySegment> | null> = (state = initialState, action) => {
  switch (action.type) {
    case DaySegments.CREATE_DAY_SEGMENT_SUCCESS: {
      const response = action.payload;

      return {
        ...state,
        data: [...(state.data || []), response],
        total: state.total + 1,
      };
    }
    case DaySegments.GET_DAY_SEGMENTS_SUCCESS: {
      const response = action.payload;

      return response;
    }
    case DaySegments.UPDATE_DAY_SEGMENT_SUCCESS: {
      const response = action.payload;

      return {
        ...state,
        data: state?.data.map((daySegment) => (daySegment.id === response.id ? response : daySegment)) || [],
      };
    }
    case DaySegments.DELETE_DAY_SEGMENT_SUCCESS: {
      const response = action.payload;

      return {
        ...state,
        data: [...state.data.filter((daySegment) => daySegment.id !== response.id)],
        total: state.total - 1,
      };
    }
    case DaySegments.REPLACE_DAY_SEGMENTS_SUCCESS: {
      const response = action.payload;

      return {
        ...state,
        data: response,
        total: response.length,
      };
    }
    default: {
      return state;
    }
  }
};
